import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DocumentTitle: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    if (path.includes('/citizenship')) {
      document.title = 'Citizenship Reimbursement';
    } else if (path.includes('/tuition')) {
      document.title = 'Tuition Reimbursement';
    } else if (path.includes('/login') || path.includes('/auth')) {
      document.title = 'Citizenship/Tuition Reimbursement';
    } else {
      document.title = 'Citizenship/Tuition Reimbursement';
    }
  }, [location.pathname]);

  return null;
};

export default DocumentTitle;
